"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteEditCell = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const useAutocomplete_1 = require("@mui/material/useAutocomplete");
const classnames_1 = __importDefault(require("classnames"));
const debounce_1 = __importDefault(require("debounce"));
const autocomplete_edit_cell_listbox_component_1 = require("./autocomplete-edit-cell-listbox.component");
const autocomplete_edit_cell_styles_1 = require("./autocomplete-edit-cell.styles");
const client_constants_1 = require("../../../client/client.constants");
const generic_1 = require("../../../generic");
const localization_1 = require("../../../../localization");
const AutocompleteEditCell = ({ id, field, value, options, searchable = false, autoOpen = true, clearable = false, isLoading = false, isLoadingMore = false, hasNextPage = false, onLoadMore, onSearch, renderOption, renderValue, getOptionKey, showNoOptionsText = true, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const apiRef = (0, ui_components_1.useAdvancedGridApiContext)();
    const inputRef = (0, react_1.useRef)(null);
    const hasCommittedRef = (0, react_1.useRef)(false);
    const hasPendingClearRef = (0, react_1.useRef)(false);
    const [inputValue, setInputValue] = (0, react_1.useState)(() => {
        var _a;
        const match = options.find((o) => o.value === value);
        return (_a = match === null || match === void 0 ? void 0 : match.label) !== null && _a !== void 0 ? _a : String(value !== null && value !== void 0 ? value : '');
    });
    const [isOpen, setIsOpen] = (0, react_1.useState)(autoOpen);
    const debouncedSearch = (0, react_1.useMemo)(() => (onSearch ? (0, debounce_1.default)(onSearch, client_constants_1.SEARCH_DELAY) : undefined), [onSearch]);
    const internalOptions = (0, react_1.useMemo)(() => (options.map((option) => ({
        label: option.label,
        value: option.value,
        disabled: option.disabled,
        original: option,
    }))), [options]);
    const selectedOption = (0, react_1.useMemo)(() => { var _a; return (_a = internalOptions.find((option) => option.value === value)) !== null && _a !== void 0 ? _a : null; }, [internalOptions, value]);
    (0, react_1.useEffect)(() => {
        setInputValue((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || '');
    }, [selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label]);
    const filterOptions = (0, react_1.useMemo)(() => {
        if (onSearch || onLoadMore) {
            return (availableOptions) => availableOptions;
        }
        const defaultFilter = (0, useAutocomplete_1.createFilterOptions)();
        return (availableOptions, params) => defaultFilter(availableOptions, params);
    }, [onLoadMore, onSearch]);
    (0, react_1.useEffect)(() => {
        const frameId = requestAnimationFrame(() => {
            var _a;
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            if (autoOpen) {
                setIsOpen(true);
            }
        });
        return () => cancelAnimationFrame(frameId);
    }, [autoOpen]);
    const handleLoadMore = (0, react_1.useCallback)((event) => {
        if (!onLoadMore || isLoadingMore || !hasNextPage) {
            return;
        }
        const listboxNode = event.currentTarget;
        if (Math.floor(listboxNode.scrollTop + listboxNode.clientHeight) >= listboxNode.scrollHeight - client_constants_1.LOAD_MORE_TRIGGER_GAP) {
            void onLoadMore();
        }
    }, [hasNextPage, isLoadingMore, onLoadMore]);
    const handleInputChange = (0, react_1.useCallback)((_event, nextInputValue, reason) => {
        if (!searchable) {
            return;
        }
        if (reason === 'reset') {
            return;
        }
        setInputValue(nextInputValue);
        void (debouncedSearch === null || debouncedSearch === void 0 ? void 0 : debouncedSearch(nextInputValue));
    }, [debouncedSearch, searchable]);
    const handleChange = (0, react_1.useCallback)((_event, option, reason) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (reason === 'clear') {
            if (!clearable) {
                return;
            }
            hasPendingClearRef.current = true;
            setInputValue('');
            void (debouncedSearch === null || debouncedSearch === void 0 ? void 0 : debouncedSearch(''));
            return;
        }
        if (reason !== 'selectOption' && reason !== 'createOption') {
            return;
        }
        hasCommittedRef.current = true;
        hasPendingClearRef.current = false;
        setIsOpen(false);
        setInputValue((option === null || option === void 0 ? void 0 : option.label) || '');
        try {
            yield apiRef.current.setEditCellValue({
                id,
                field,
                value: (_a = option === null || option === void 0 ? void 0 : option.value) !== null && _a !== void 0 ? _a : null,
            });
        }
        finally {
            apiRef.current.stopCellEditMode({ id, field });
        }
    }), [apiRef, clearable, debouncedSearch, field, id]);
    const handleClose = (0, react_1.useCallback)((_event, reason) => {
        if (hasCommittedRef.current || reason === 'selectOption') {
            return;
        }
        setIsOpen(false);
        if (hasPendingClearRef.current && reason !== 'escape') {
            hasCommittedRef.current = true;
            hasPendingClearRef.current = false;
            void (() => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    yield apiRef.current.setEditCellValue({
                        id,
                        field,
                        value: null,
                    });
                }
                finally {
                    apiRef.current.stopCellEditMode({ id, field });
                }
            }))();
            return;
        }
        hasPendingClearRef.current = false;
        apiRef.current.stopCellEditMode({ id, field });
    }, [apiRef, field, id]);
    const handleOpen = (0, react_1.useCallback)(() => {
        setIsOpen(true);
    }, []);
    const handleKeyDown = (0, react_1.useCallback)((event) => {
        if (event.key !== 'Escape') {
            return;
        }
        event.stopPropagation();
        hasPendingClearRef.current = false;
        setIsOpen(false);
        apiRef.current.stopCellEditMode({ id, field });
    }, [apiRef, field, id]);
    const renderAutocompleteOption = (0, react_1.useCallback)((props, option, _state) => {
        const { key } = props, optionProps = __rest(props, ["key"]);
        const optionKey = option.original && getOptionKey
            ? getOptionKey(option.original)
            : key;
        return (react_1.default.createElement("li", Object.assign(Object.assign({}, optionProps), { key: optionKey, style: props.style }), option.original && renderOption
            ? renderOption(option.original)
            : option.label));
    }, [getOptionKey, renderOption]);
    const listboxProps = {
        onScroll: handleLoadMore,
        moreItemsLoading: isLoadingMore,
        className: (0, classnames_1.default)({ 'list--loading': isLoading }),
    };
    const loadingText = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "autocomplete-edit-cell-dropdown-loading" }, react_1.default.createElement(generic_1.LoadingIndicator, { className: "loading-indicator" }))), []);
    const noOptionsText = (0, react_1.useMemo)(() => {
        if (isLoading || !showNoOptionsText) {
            return '';
        }
        if (searchable && onSearch && options.length === 0 && !inputValue.trim()) {
            return '';
        }
        return t({ key: 'NO_DATA_AVAILABLE' });
    }, [inputValue, isLoading, onSearch, options.length, searchable, showNoOptionsText, t]);
    const selectedDisplayValue = !searchable && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.original)
        ? (react_1.default.createElement("div", { className: "autocomplete-edit-cell-display-value" }, renderValue ? renderValue(selectedOption.original) : selectedOption.label))
        : null;
    return (react_1.default.createElement(autocomplete_edit_cell_styles_1.StyledAutocompleteEditCellWrapper, null, react_1.default.createElement(autocomplete_edit_cell_styles_1.StyledAutocompleteEditCell, Object.assign(Object.assign({ className: (0, classnames_1.default)('autocomplete-edit-cell', {
            'non-searchable': !searchable,
            'non-clearable': !clearable,
        }), openOnFocus: true, autoHighlight: true, disablePortal: true, disableClearable: !clearable, open: isOpen, selectOnFocus: searchable, clearOnBlur: false, handleHomeEndKeys: true, loading: isLoading, options: internalOptions, value: selectedOption }, (searchable
        ? {
            inputValue,
            onInputChange: handleInputChange,
        }
        : {})), { onChange: handleChange, onOpen: handleOpen, onClose: handleClose, onKeyDown: handleKeyDown, PopperComponent: autocomplete_edit_cell_styles_1.StyledAutocompleteEditCellPopper, PaperComponent: autocomplete_edit_cell_styles_1.StyledAutocompleteEditCellPaper, ListboxComponent: autocomplete_edit_cell_listbox_component_1.AutocompleteEditCellListbox, ListboxProps: listboxProps, getOptionDisabled: (option) => Boolean(option.disabled), isOptionEqualToValue: (option, selected) => option.value === selected.value, getOptionLabel: (option) => option.label, filterOptions: filterOptions, loadingText: loadingText, noOptionsText: noOptionsText, renderOption: renderAutocompleteOption, renderInput: (params) => (react_1.default.createElement(ui_components_1.TextField, Object.assign(Object.assign({}, params), { inputRef: inputRef, autoFocus: true, variant: "outlined", placeholder: searchable ? t({ key: 'SEARCH' }) : undefined, InputProps: Object.assign(Object.assign({}, params.InputProps), { startAdornment: selectedDisplayValue || params.InputProps.startAdornment, endAdornment: params.InputProps.endAdornment }) }))) }))));
};
exports.AutocompleteEditCell = AutocompleteEditCell;
